module.exports = __webpack_public_path__ + "static/media/window2.b8c6ecfb.jpg";